import { extInfo } from 'lib/extInfo';
import { DEFAULT_FILES_HASHES } from 'reactApp/constants/magicIdentificators';
import {
    FeedCategoryType,
    FeedItemApiResponse,
    FeedItemBase,
} from 'reactApp/modules/feed/feed.types';
import { getExtension, getItemNameWithoutExt, getParent, isFolder, normalizeId, normalizePublicApiInfo } from 'reactApp/modules/file/utils';
import { AddFile } from 'reactApp/modules/modifying/modifying.types';
import { UrlBuilder } from 'reactApp/modules/urlBuilder/UrlBuilder';
import { normalizeMtime } from 'reactApp/utils/tree.helpers';

const urlBuilder = new UrlBuilder();

export const filterOutDefaultContentAdnFoldersItems = (item) => !isFolder(item) && !(item.hash && DEFAULT_FILES_HASHES.includes(item.hash));

export const getExtensionByCategory = (category: FeedCategoryType) => {
    const otherDocumentTypes = ['pdf', 'xml', 'djvu', 'xps', 'pages'];

    const feedCategoryFnMap = {
        document: (feedCategory: FeedCategoryType) => extInfo.getExtsByKind(feedCategory).concat(otherDocumentTypes).join(','),
        all: () => undefined,
        default: (feedCategory: FeedCategoryType) => extInfo.getExtsByKind(feedCategory).join(','),
    } as const;

    return (feedCategoryFnMap[category] || feedCategoryFnMap['default'])(category);
};

export const normalizeBaseFeedItem = (feedItem: FeedItemApiResponse | AddFile, mountedFoldersIds?: Nullable<string[]>) => {
    const item = feedItem as FeedItemApiResponse | AddFile;

    const parentFolder = normalizeId(getParent(item.home));
    const ext = getExtension(item);
    const nameWithoutExt = getItemNameWithoutExt(item.name, ext);
    const { kind, subKind } = extInfo.get(ext);

    const isReadOnly = Boolean(mountedFoldersIds?.some((mountedFolderId) => item.home.includes(mountedFolderId)));

    const normalizedItem: FeedItemBase = {
        isReadOnly,
        id: item.home,
        isFolder: false,
        parent: parentFolder,
        ext,
        nameWithoutExt,
        name: item.name,
        home: item.home || '',
        size: item.size,
        kind,
        subKind,
        mtime: normalizeMtime(item.mtime),
        virusScan: item.virus_scan,
        hash: item.hash,
        uflr: 'uflr' in item ? item.uflr : undefined,
        isInFavorites: 'favorite' in item && (item.favorite === 1 || item.favorite === true),
        weblink: '',
        url: urlBuilder.getUrls({
            ext,
            isPublic: false,
            id: item.home,
            weblink: '',
            size: item.size,
            kind,
            subKind,
            isStock: false,
            name: item.name,
            path: item.home,
        }),
        thumbnails: urlBuilder.getThumb({
            hash: item.hash,
            ext,
            id: item.home,
            size: item.size,
            kind,
            name: item.name,
            path: item.home,
            isPublic: false,
            isStock: false,
            dwl_token: null,
            weblink: '',
        }),
    };

    if ('public' in item && item.public) {
        return {
            ...normalizedItem,
            ...normalizePublicApiInfo(item),
        };
    }

    return normalizedItem;
};
